<template>
<b-container fluid>
  <b-alert v-if="alert.message != ''" :variant="alert.variant">{{alert.message}}</b-alert>
  <h1>Part Locator</h1>
  <b-row align-h="center">
    <b-form @submit="searchParts" inline>
      <b-form-input placeholder="Part Number" v-model="form.partNumber" class="mx-1" />
      <b-form-input placeholder="Part Description" v-model="form.partDescription" class="mx-1" />
      <b-form-input placeholder="Current Location" v-model="form.partLocation" class="mx-1" />
      <b-btn type=submit variant=primary class="mx-1">Search Parts</b-btn>
    </b-form>
  </b-row>
  <section v-if="items.length > 0" class="mx-2">
    <b-row class="mt-2">
      <b-col cols=8>
        <b-form-input v-model="filter" placeholder="Filter" />
      </b-col>
      <b-col>
      </b-col>
    </b-row>
    <b-row class="my-1">
      <b-table
        :items="items" :fields="fields" class="my-0 fixed-table"
        :busy="busy"
        :filter="filter" @filtered="onFilter"
      >
        <template slot="location" slot-scope="data">
          <div v-if="data.item.locationgroup">
            {{data.item.locationgroup}}>{{data.item.locationname}}
          </div>
        </template>
        <template slot="deflocation" slot-scope="data">
            {{data.item.defaultlocation}}
        </template>
        <template slot="pickable" slot-scope="data">
          <div v-if="data.item.pickable">
            Y
          </div>
          <div v-else>
            N
          </div>
        </template>
        <template slot="qty" slot-scope="data">
          <div v-if="data.item.qty">
            {{Number(data.item.qty)}} {{data.item.uom}}
          </div>
          <div v-else>
            0 ea
          </div>
        </template>
        <template slot="qtycommitted" slot-scope="data">
          <div v-if="data.item.qtycommitted">
            {{Number(data.item.qtycommitted)}} {{data.item.uom}}
          </div>
          <div v-else>
            0 ea
          </div>
        </template>
      </b-table>
    </b-row>
  </section>
</b-container>
</template>

<script>
import axios from 'axios';
import NiceDate from '../utility/NiceDate';
const BASE_API = process.env.VUE_API_ROOT;

export default {
  components: {
    NiceDate,
  },
  data() {
    return {
      alert: {
        variant: 'danger',
        message: '',
      },
      form: {
        partNumber: '',
        partDescription: '',
        partLocation: '',
      },
      busy: false,
      fields: [
        { key: 'partnum', label: 'Part Number', sortable: true },
        { key: 'description', label: 'Description', sortable: true },
        { key: 'location', label: 'Current Location', sortable: true, sortByFormatted: true, formatter: (val, k, i) =>  `${i.locationgroup}>${i.locationname}`  },
        { key: 'deflocation', label: 'AMHQ Default Location', sortable: true, sortByFormatted: true, formatter: (val, k, i) => i.defaultlocation },
        { key: 'pickable', label: 'Pickable', sortable: true },
        { key: 'qty', label: 'Quantity', sortable: true },
        { key: 'qtycommitted', label: 'Quantity Committed', sortable: true },
      ],
      items: [],
      filter: '',
      perPage: 20,
      currentPage: 1,
      totalRows: 0,
    }
  },
  methods: {
    searchParts(evt) {
      evt.preventDefault();
      this.alert.message = '';

      this.busy = true;
      axios({
        method: 'post',
        headers: { 'Content-Type': 'text/plain' },
        url: `${BASE_API}/fishbowl/parts/search`,
        data: this.form,
      }).then((response) => {
        this.items = response.data;
        this.totalRows = this.items.length;
        if (this.totalRows == 0) {
          this.alert.variant = 'warning';
          this.alert.message = 'No Orders Found';
        }
        this.busy = false;
      }).catch((error) => {
        this.alert.variant = 'danger';
        this.alert.message = 'Search Failed. See console for more information';
        console.error(error);
      });
    },
    onFilter(items) {
      this.totalRows = items.length;
      this.currentPage = 1;
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/inventory/PartLocator.vue